import UnsavedEditScope from './UnsavedEditScope';

export default UnsavedEditScope;
